
import { makeStyles } from 'tss-react/mui';

export const useAdminLayoutStyles = makeStyles<AdminDrawerStyleProps>({ name: 'AdminLayout' })((theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  root: {
    display: 'flex',
    flex: 1,
    position: 'relative'
  }
}));

type AdminDrawerStyleProps = {
  width: number;
};

export const useAdminDrawerStyles = makeStyles<AdminDrawerStyleProps>({ name: 'AdminDrawer' })((theme, { width }) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    width: width - 16, // account for padding
  },
  drawer: {
    flexShrink: 0,
    position: 'relative',
    width: `${width}px`,
    zIndex: theme.zIndex.appBar - 1
  },
  drawerClosed: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: '30px',
  },
  drawerOpen: {
    width: `${width}px`,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  footer: {
    display: 'flex',
    flex: 0,
    flexDirection: 'column',
    gridGap: theme.spacing(2),
    justifyContent: 'center',
    padding: theme.spacing(2, 3),
  },
  footerLinkBox: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: '4px',
    fontSize: '14px'
  },
  hide: {
    visibility: 'hidden',
  },
  menu: {
    flex: 1,
    whiteSpace: 'nowrap',
  },
  toggleButton: {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '50%',
    boxSizing: 'border-box',
    height: '24px',
    padding: 0,
    position: 'fixed',
    top: '160px',
    width: '24px',
    zIndex: 1,
    '&:hover': {
      backgroundColor: theme.palette.common.white,
    }
  },
  toggleClosed: {
    left: 'calc(30px - 12px)',
    transition: theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  toggleOpen: {
    left: `${width - 12}px`,
    transition: theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  plan: {
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '1px',
    textTransform: 'uppercase'
  },
}));
